<template>
  <div class="statistical-warn">
    <div class="statistical-warn-top">
      <div class="warn-item-box">
        <div class="warn-item-logo-t"></div>
        <div class="warn-item-box-msg">
          <div class="item-title">温度数据预警</div>
          <div class="item-number-t">{{warningData.tempWarning}}</div>
        </div>
      </div>
      <div class="warn-item-box">
        <div class="warn-item-logo-h"></div>
        <div class="warn-item-box-msg">
          <div class="item-title">湿度数据预警</div>
          <div class="item-number-h">{{warningData.moistureWarning}}</div>
        </div>
      </div>
      <div class="warn-item-box">
        <div class="warn-item-logo-w"></div>
        <div class="warn-item-box-msg">
          <div class="item-title">水份预警</div>
          <div class="item-number-w">{{warningData.wetWarning}}</div>
        </div>
      </div>
      <div class="warn-item-box">
        <div class="warn-item-logo-o"></div>
        <div class="warn-item-box-msg">
          <div class="item-title">氧气预警</div>
          <div class="item-number-o">{{warningData.o2Warning}}</div>
        </div>
      </div>
      <div class="warn-item-box">
        <div class="warn-item-logo-c"></div>
        <div class="warn-item-box-msg">
          <div class="item-title">二氧化碳预警</div>
          <div class="item-number-c">{{warningData.co2pWarning}}</div>
        </div>
      </div>
    </div>
    <div class="statistical-warn-bottom">
      <div class="statistical-select-box">
        <div class="statistical-select-box-l">
          <div class="input-date-wrapper">
            <el-date-picker
              v-model="value"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div style="margin-right: 1vw">
            <LoadingTreeStack :moduleType="moduleType"  :content="siteName" :editCheckId="siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
          </div>
          <div style="margin-right: 1vw">
            <DropDown content="请选择传预警类型" :items="warningTypeData" v-on:sendInfo = "showInfo"></DropDown>
          </div>
          <div class="query button" @click="handleSearch">查询</div>
        </div>
        <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      </div>
      <div class="loading-data" v-if="loading">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后···</div>
      </div>
      <div class="chart-wrapper" v-show="!loading" id="myChart15" v-if="rows.length > 0"></div>
      <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
      <img class="warn-icon" src="../../../assets/content-box.png"/>
    </div>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import {earlyStatistics} from '../../../api/maintain'
let echarts = require('echarts')
let myChart15
export default {
  name: 'StatisticalWarn',
  components: { DropDown, LoadingTreeStack },
  data () {
    return {
      loading: true,
      value: '',
      moduleType: '-1',
      warningTypeData: [
        {name: '全部', value: ''},
        {name: '温度数据预警', value: 1},
        {name: '湿度数据预警', value: 2},
        {name: '水份预警', value: 3},
        {name: '氧气预警', value: 4},
        {name: '二氧化碳预警', value: 5}
      ],
      warningData: {
        tempWarning: 0,
        wetWarning: 0,
        moistureWarning: 0,
        o2Warning: 0,
        co2pWarning: 0
      },
      rows: [],
      startTime: '',
      endTime: '',
      siteId: '',
      siteType: '',
      siteName: '',
      warningType: ''
    }
  },
  created () {
    this.handleSearch()
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    showInfo: function (data) {
      console.log(data)
      this.warningType = data.value
    },
    showDropInfo: function (data) {
      console.log(data)
      this.siteName = data.gatherSite
      this.siteId = data.id
      this.siteType = data.siteType
    },
    handleSearch: function () {
      this.loading = true
      let body = {
        startTime: this.startTime,
        endTime: this.endTime,
        siteId: this.siteId,
        siteType: this.siteType,
        warningType: this.warningType
      }
      console.log(body)
      earlyStatistics(body).then(res => {
        console.log(res)
        this.loading = false
        this.rows = res.data.yearMonthArray
        let that = this
        if (res.data.warningTypeArray) {
          this.warningData.tempWarning = res.data.warningTypeArray.tempWarning || 0
          this.warningData.wetWarning = res.data.warningTypeArray.wetWarning || 0
          this.warningData.moistureWarning = res.data.warningTypeArray.moistureWarning || 0
          this.warningData.o2Warning = res.data.warningTypeArray.o2Warning || 0
          this.warningData.co2pWarning = res.data.warningTypeArray.co2pWarning || 0
        }
        if (res.data.yearMonthArray && res.data.yearMonthArray.length > 0) {
          setTimeout(function () {
            that.getCharts()
          }, 200)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getCharts: function () {
      this.getChart15(0)
      window.onresize = function () {
        myChart15.resize()
      }
    },
    getChart15: function () {
      let date = []
      let value = []
      if (this.rows.length < 12) {
        this.percentage = 100
      } else {
        this.percentage = 1200 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.createdTime)
        value.push(item.warningCount)
      })
      myChart15 = echarts.init(document.getElementById('myChart15'))
      myChart15.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'}
          }
        },
        textStyle: {color: '#00d2ff'},
        legend: {
          x: 'right',
          y: 'top',
          itemGap: 50,
          textStyle: {color: '#01c5f1'},
          data: [
            {name: '预警数量', icon: 'square'}
          ]
        },
        grid: {
          top: '10%',
          right: '4%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '月份',
          splitLine: {show: false},
          axisTick: false,
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          axisLabel: {
            interval: 0
          },
          data: date
        },
        yAxis: {
          type: 'value',
          scale: 'true',
          axisTick: false,
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: ['#2a2f57']
            }
          },
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          splitNumber: '5',
          name: '次数（次）'
        },
        dataZoom: [
          {
            show: false,
            start: 0,
            end: this.percentage
          },
          {
            type: 'inside',
            start: 0,
            end: this.percentage
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 30,
            height: '80%',
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            barWidth: '40%',
            name: '预警次数',
            type: 'bar',
            symbol: 'circle',
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#32b16c'
                },
                color: '#32b16c',
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 16
                  }
                }
              }
            },
            data: value
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
@import "Warn.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warn/StatisticalWarn.vue